import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";

import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../../util/varios';
import TablaDeudaComercio from '../actividadEconomica/tablaDeudaComercios';
import TablaPagosComercio from '../actividadEconomica/tablaPagosComercios';
import TablaFacturasContribuyente from '../actividadEconomica/tablaFacturasContribuyentes';
import TablaHistoricoRetenciones from '../actividadEconomica/tablaHistoricoRetenciones'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import TablaIndole from './tablaIndole';
import moment from 'moment';
import TablaTributaria from './tablaDatosTributarios';
import TablaDeudaLicores from './tablaDeudaLicores';
import TablaHistoricoLicores from './tablaHistoricoLicores';
import axios from 'axios';
import CatalogoIndole from '../../../catalogos/catalogoIndoleExpendio';



export const ModalExpendio = (props) => {

    /*  variables de estados */

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrarModal, setMostrarModal] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const txtCodigoCiu = useRef();
    const txtIdactividad = useRef();
    const txtAlicuota = useRef();
    const txtDescripcionActi = useRef();
    const txtAnios = useRef();
    const txtMinimo = useRef();
    const txtActualizada = useRef();
    const txtCodActividad = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [disaLicencia, setDisaLicencia] = useState(true)
    const txtDescripcion = useRef();
    const txtId = useRef();
    const txtHorario = useRef();
    const txtbtn = useRef();
    const txtLicencia = useRef();



    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };

    const blanquear = () => {
        txtId.current.value = '';
        txtDescripcion.current.value = '';
        txtHorario.current.value = '';
        txtLicencia.current.value = ''
    }

    const handleCloseMensa = () => {
        setMostrar(false);
        if (msg == 'registro creado correctamente.' || msg == 'registro eliminado correctamente.') {
            blanquear()
            props.onHideCancela();
            props.onHideRenderIndole(props.comercio)
            props.onHideRenderDeu(props.comercio)
        }
    }

    const handleCloseModal = () => {
        setMostrarModal(false);
    }

    const abrirCatalogo = () => {
        setMostrarModal(true);
    }

    const onChange = (event) =>{

        if(event.target.name === 'licencia'){
            event.target.value = event.target.value.toUpperCase()
        }

    }


    const handleInputChange = (event) => {
        if (event.which === 13) {
            if (event.target.id === 'inputCodigo') {
                txtCodActividad.current.focus();
            } else if (event.target.id === 'inputCodigoActi') {
                txtCodigoCiu.current.focus();
            } else if (event.target.id === 'inputCodigoCiu') {
                txtAnios.current.focus();
            } else if (event.target.id === 'inputAnio') {
                txtDescripcionActi.current.focus();
            } else if (event.target.id === 'inputDescripcion') {
                txtAlicuota.current.focus();
            } else if (event.target.id === 'inputActualizada') {
                btnAcepta.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            return false;
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
          }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === 'inputAlicuota') {
                    txtMinimo.current.focus();
                } else if (event.target.id === 'inputMinimo') {
                    txtActualizada.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.which === 13) {
                if (event.target.id === 'inputAnio') {
                    txtDescripcionActi.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const salir = () => {

        props.onHideCancela();
    }


    /* ******************************************************    funciones      ************************************************************ */

    const handleAceptaIndole = (id, descrip) => {
        setMostrarModal(false);
        txtId.current.value = id;
        txtDescripcion.current.value = descrip;
        seleccionarTipoExpendio(id)


    }



    const seleccionarTipoExpendio = (id) => {

        let endpoint = `${op.conexion}/api/licores/tipoexpendio?&id=${id}`


        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log('se conecto a tipo expendio')
                let horaabierto = response.data[0].horaabierto;
                let apabierto = response.data[0].apabierto;
                let horacerrado = response.data[0].horacerrado;
                let apcerrado = response.data[0].apcerrado
                txtHorario.current.value = "Desde " + horaabierto + " " + apabierto + " Hasta " + horacerrado + " " + apcerrado;

                console.log('info tipo expendio')
                console.log(response.data[0])
                setDisaLicencia(false)
                txtLicencia.current.focus()


            }

        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })
    }

    const insertarExpendio = () => {

        let endpoint = `${op.conexion}/api/licores/insertarexpendio`;
        let body;
        setActivate(true);

        body = {
            idcomercio: parseInt(props.idcomercio),
            idtipoexpendio: txtId.current.value,
            licencia: txtLicencia.current.value
        };

        console.log(body)

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {



                if (props.operacion === 1) {


                    setTitulo("Notificacion");
                    setMsg("registro creado correctamente.")
                    setMostrar(true)

                }

            }
            setActivate(false);
        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const eliminarExpendio = () => {

        let endpoint = `${op.conexion}/api/licores/eliminarexpendio`;
        let body;
        setActivate(true);

        body = {
            idcomercio: parseInt(props.idcomercio),
            idtipoexpendio: txtId.current.value


        };


        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {



                if (props.operacion === 3) {


                    setTitulo("Notificacion");
                    setMsg("registro eliminado correctamente.")
                    setMostrar(true)

                }

            }
            setActivate(false);
        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const validar = () => {

        let sigue = true

        if (txtId.current.value === '') {
            setTitulo("Notificacion");
            setMsg("Debe seleccionar un expendio.")
            setMostrar(true)
            sigue = false
        } else if (txtLicencia.current.value === ''){
            setTitulo("Notificacion");
            setMsg("Debe seleccionar un expendio.")
            setMostrar(true)
            txtLicencia.current.focus()
        }
        else if (sigue) {
            if (operacion === 1) {
                insertarExpendio()
            } else if (operacion === 3) {
                eliminarExpendio()
            }
        }


    }



    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setDeshabilitado(props.deshabilitado);
                setOperacion(props.operacion);
                if (props.operacion === 1) {
                    blanquear()
                }
                setDisaLicencia(true)



            }}
            className='shadow-lg'

        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Incluir Tasa</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body >
                <CatalogoIndole
                    show={mostrarModal}
                    onHideCancela={handleCloseModal}
                    onHideAceptaIndole={handleAceptaIndole}
                />

                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='col-md-12 row' style={{ height: "auto", overflow: "auto" }}>


                    <div className="input-group input-group-sm col-md-4">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Codigo:</span>
                        </div>
                        <input type="text" disabled ref={txtId} className="form-control form-control-sm" defaultValue={props.expendio ? props.expendio.idtipoexpendio !== null ? props.expendio.idtipoexpendio.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                        <button ref={txtbtn} style={{ textAlign: "center", color: "white" }} onClick={abrirCatalogo} className="btn btn-sm btn-info"><i className="fas fa-search"> Buscar</i> </button>
                    </div>
                    <div className='col-md-3'></div>
                    <div className="input-group input-group-sm col-md-5">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Licencia:</span>
                        </div>
                        <input type="text" ref={txtLicencia} disabled={disaLicencia} className="form-control form-control-sm" defaultValue={props.expendio ? props.expendio.licencia !== null ? props.expendio.licencia.trim() : '' : ''} id="inputLicencia" name='licencia' onChange={onChange}/>
                    </div>

                    <div className="input-group input-group-sm col-md-12" >
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Descripcion: </span>
                        </div>
                        <textarea type="area" disabled rows={1} ref={txtDescripcion} className="form-control form-control-sm" id="inputDireccionContri" defaultValue={props.expendio ? props.expendio.descripcion !== null ? props.expendio.descripcion.trim() : '' : ''} onKeyUp={handleInputChange} />
                    </div>

                    <div className="input-group input-group-sm col-md-12" >
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Horario: </span>
                        </div>
                        <input type="text" disabled ref={txtHorario} className="form-control form-control-sm" defaultValue={props.expendio ? "Desde: " + props.expendio.horaabierto + ' ' + props.expendio.apabierto + 'hasta: ' + props.expendio.horacerrado + ' ' + props.expendio.apcerrado : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer >
                <button className="btn btn-sm btn-success rounded-pill col-md-2" onClick={validar} ><i className="fas"> Aceptar</i></button>

                <button ref={btnCancela} onClick={salir} className="btn btn-sm btn-danger rounded-pill col-md-2"><i className="fas fa-window-close"> Salir</i></button>

            </Modal.Footer>
        </Modal>
    );
}